var moment = require('moment')
var _ = require('lodash')



export function resampleDaysTss(dates,tss) {
    if (dates.length<5){
        return  [dates, tss]
    }
        
    let timeUnit = 'day'
    //console.log("date",dates,"tss",tss)
    let startTime = moment(dates[0]).startOf(timeUnit)
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: tss[0]}]
    
    for (var i = 1; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: tss[i] })
        //sampleTime.add(24, 'hours')
    }
    
    //let endTime = moment(dates[dates.length-1])
    let endTime = moment().add(60,'day')


    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesReduced = _.reduce(datesResampled, function (result, value, key) {
        result[value.x.valueOf()] = value
        return result
    }, {})

    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, 'day')
    }

    var resampledDates = []
    var resampledTss = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
        resampledTss.push(value.y)
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

    return [resampledDates, resampledTss]
}


export function resampleDistance(dates,distance,timeframe){
    if(!resampleDistance.cache){
        resampleDistance.cache = {}
    }
    if(resampleDistance.cache.distance != undefined && resampleDistance.cache.distance!= null){
        if(arraysEqual(distance,resampleDistance.cache.distanceOrigin) && resampleDistance.cache.timeframe == timeframe){
            return [resampleDistance.cache.dates,resampleDistance.cache.distance]
        }
        
    }
    
    //console.log(resampleDistance.cache)
    const [resampledDates, resampleddistance] = resampleDistanceOriginal(dates,distance,timeframe)
    resampleDistance.cache.distance = resampleddistance
    resampleDistance.cache.dates = resampledDates
    resampleDistance.cache.distanceOrigin = distance
    resampleDistance.cache.datesOrigin = dates
    resampleDistance.cache.timeframe = timeframe
    return [resampledDates, resampleddistance]
    
    
}
export function resampleDistanceOriginal(dates,distance,timeframe) {
    if (dates.length<5){
        return  [dates, distance]
    }
        
    let timeUnit = timeframe
    //console.log("date",dates,"distance",distance)
    let startTime = moment(dates[0]).subtract(2,'month').startOf(timeUnit)
    if (timeframe === 'year'){
        startTime = moment(dates[0]).subtract(1,'year').startOf(timeUnit)
    }
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: 0}]
    
    for (var i = 0; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: distance[i] })
        //sampleTime.add(24, 'hours')
    }
    let endTime = moment().add(2,'month')
    //let endTime = moment(dates[dates.length-1])
    if (timeframe === 'year'){
        endTime = moment().add(1,'year')
    }
    

    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })
    //console.log(dates)
    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                sum = sum + datesResampled[j].y
                
            }  
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, timeframe)
    }

    var resampledDates = []
    var resampleddistance = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampleddistance.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

    return [resampledDates, resampleddistance]
}

export function resampleDuration(dates,duration,timeframe){
    if(!resampleDuration.cache){
        resampleDuration.cache = {}
    }
    if(resampleDuration.cache.duration != undefined && resampleDuration.cache.duration!= null){
        if(arraysEqual(duration,resampleDuration.cache.durationOrigin  && resampleDistance.cache.timeframe == timeframe)){
            return [resampleDuration.cache.dates,resampleDuration.cache.duration]
        }
        
    }
    
    //console.log(resampleDuration.cache)
    const [resampledDates, resampledduration] = resampleDurationOriginal(dates,duration,timeframe)
    resampleDuration.cache.duration = resampledduration
    resampleDuration.cache.dates = resampledDates
    resampleDuration.cache.durationOrigin = duration
    resampleDuration.cache.datesOrigin = dates
    resampleDuration.cache.timeframe = timeframe
    return [resampledDates, resampledduration]
    
    
}
export function resampleDurationOriginal(dates,duration,timeframe) {
    if (dates.length<5){
        return  [dates, duration]
    }
        
    let timeUnit = timeframe
    //console.log("date",dates,"duration",duration)
    let startTime = moment(dates[0]).subtract(2,'month').startOf(timeUnit)
    if (timeframe === 'year'){
        startTime = moment(dates[0]).subtract(1,'year').startOf(timeUnit)
    }
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: 0}]
    
    for (var i = 0; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: duration[i] })
        //sampleTime.add(24, 'hours')
    }
    let endTime = moment().add(2,'month')
    //let endTime = moment(dates[dates.length-1])
    if (timeframe ==='year'){
        endTime = moment().add(1,'year')
    }
    

    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })
    //console.log(dates)
    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                sum = sum + datesResampled[j].y
                
            }  
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, timeframe)
    }

    var resampledDates = []
    var resampledduration = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledduration.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

    return [resampledDates, resampledduration]
}


/// with no space in the start or the end




export function resampleDistanceNoEnd(dates,distance,timeframe){
    if(!resampleDistanceNoEnd.cache){
        resampleDistanceNoEnd.cache = {}
    }
    if(resampleDistanceNoEnd.cache.distance != undefined && resampleDistanceNoEnd.cache.distance!= null){
        if(arraysEqual(distance,resampleDistanceNoEnd.cache.distanceOrigin)){
            return [resampleDistanceNoEnd.cache.dates,resampleDistanceNoEnd.cache.distance]
        }
        
    }
    
    //console.log(resampleDistanceNoEndOriginal.cache)
    const [resampledDates, resampleddistance] = resampleDistanceNoEndOriginal(dates,distance,timeframe)
    resampleDistanceNoEnd.cache.distance = resampleddistance
    resampleDistanceNoEnd.cache.dates = resampledDates
    resampleDistanceNoEnd.cache.distanceOrigin = distance
    resampleDistanceNoEnd.cache.datesOrigin = dates
    return [resampledDates, resampleddistance]
    
    
}
export function resampleDistanceNoEndOriginal(dates,distance,timeframe) {
    if (dates.length<5){
        return  [dates, distance]
    }
        
    let timeUnit = timeframe
    //console.log("date",dates,"distance",distance)
    let startTime = moment(dates[0]).startOf(timeUnit)
   
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: 0}]
    
    for (var i = 0; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: distance[i] })
        //sampleTime.add(24, 'hours')
    }
    let endTime = moment()
    //let endTime = moment(dates[dates.length-1])
    
    

    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })
    //console.log(dates)
    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                sum = sum + datesResampled[j].y
                
            }  
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, timeframe)
    }

    var resampledDates = []
    var resampleddistance = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampleddistance.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

    return [resampledDates, resampleddistance]
}











//////////////////////////this is my personal algorithm for resample. This is the one that i use on training load



//////// this is the cached version ////////////////////
export function resampleTssMy(dates,tss){
    if(!resampleTssMy.cache){
        resampleTssMy.cache = {}
    }
    if(resampleTssMy.cache.tss != undefined && resampleTssMy.cache.tss != null){
        if (arraysEqual(tss,resampleTssMy.cache.tssOrigin)){
            return [resampleTssMy.cache.dates,resampleTssMy.cache.tss]
        }
        
    }
    
    //console.log(resampleTssMyOriginal.cache)
    const [resampledDates, resampledTss] = resampleTssMyOriginal(dates,tss)
    resampleTssMy.cache.tss = resampledTss
    resampleTssMy.cache.dates = resampledDates
    resampleTssMy.cache.tssOrigin = tss
    resampleTssMy.cache.datesOrigin = dates
    return [resampledDates, resampledTss]
    
    
}

function resampleTssMyOriginal(dates,tss) {
    if (dates.length<5){
        return  [dates, tss]
    }
    
    let timeUnit = 'day'
    //console.log("date",dates,"tss",tss)
    let startTime = moment(dates[0]).startOf(timeUnit)
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: tss[0]}]
    
    for (var i = 1; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: tss[i] })
        //sampleTime.add(24, 'hours')
    }
    
    //let endTime = moment(dates[dates.length-1])
    let endTime = moment().add(60,'day')


    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(i!=j){
                if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                    //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                    sum = sum + datesResampled[j].y 
                }  
            }
            
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, 'day')
    }

    var resampledDates = []
    var resampledTss = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledTss.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

   
    return [resampledDates, resampledTss]
}


export function resampleTssMy2(dates,tss){
    if(!resampleTssMy2.cache){
        resampleTssMy2.cache = {}
    }
    if(resampleTssMy2.cache.tss != undefined && resampleTssMy2.cache.tss != null){
        if (arraysEqual(tss,resampleTssMy2.cache.tssOrigin)){
            return [resampleTssMy2.cache.dates,resampleTssMy2.cache.tss]
        }
        
    }
    
    //console.log(resampleTssMy2Original.cache)
    const [resampledDates, resampledTss] = resampleTssMy2Original(dates,tss)
    resampleTssMy2.cache.tss = resampledTss
    resampleTssMy2.cache.dates = resampledDates
    resampleTssMy2.cache.tssOrigin = tss
    resampleTssMy2.cache.datesOrigin = dates
    return [resampledDates, resampledTss]
    
    
}
export function resampleTssMy2Original(dates,tss) {
    if (dates.length<5){
        return  [dates, tss]
    }
    
    let timeUnit = 'day'
    //console.log("date",dates,"tss",tss)
    let startTime = moment(dates[0]).startOf(timeUnit)
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: tss[0]}]
    
    for (var i = 1; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: tss[i] })
        //sampleTime.add(24, 'hours')
    }
    
    //let endTime = moment(dates[dates.length-1])
    let endTime = moment().add(60,'day')


    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(i!=j){
                if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                    //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                    sum = sum + datesResampled[j].y 
                }  
            }
            
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, 'day')
    }

    var resampledDates = []
    var resampledTss = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledTss.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

   
    return [resampledDates, resampledTss]
}
export function resampleTssMy3(dates,tss){
    if(!resampleTssMy3.cache){
        resampleTssMy3.cache = {}
    }
    if(resampleTssMy3.cache.tss != undefined && resampleTssMy3.cache.tss != null){
        if (arraysEqual(tss,resampleTssMy3.cache.tssOrigin)){
            return [resampleTssMy3.cache.dates,resampleTssMy3.cache.tss]
        }
        
    }
    
    //console.log(resampleTssMy2Original.cache)
    const [resampledDates, resampledTss] = resampleTssMy3Original(dates,tss)
    resampleTssMy3.cache.tss = resampledTss
    resampleTssMy3.cache.dates = resampledDates
    resampleTssMy3.cache.tssOrigin = tss
    resampleTssMy3.cache.datesOrigin = dates
    return [resampledDates, resampledTss]
    
    
}
export function resampleTssMy3Original(dates,tss) {
    if (dates.length<5){
        return  [dates, tss]
    }
    
    let timeUnit = 'day'
    //console.log("date",dates,"tss",tss)
    let startTime = moment(dates[0]).startOf(timeUnit)
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: tss[0]}]
    
    for (var i = 1; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: tss[i] })
        //sampleTime.add(24, 'hours')
    }
    
    //let endTime = moment(dates[dates.length-1])
    let endTime = moment().add(60,'day')


    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(i!=j){
                if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                    //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                    sum = sum + datesResampled[j].y 
                }  
            }
            
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, 'day')
    }

    var resampledDates = []
    var resampledTss = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledTss.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

   
    return [resampledDates, resampledTss]
}

export function resampleTssMyProj(dates,tss) {
    if (dates.length<5){
        return  [dates, tss]
    }
    
    let timeUnit = 'day'
    //console.log("date",dates,"tss",tss)
    let startTime = moment(dates[0]).startOf(timeUnit)
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: tss[0]}]
    
    for (var i = 1; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: tss[i] })
        //sampleTime.add(24, 'hours')
    }
    
    //let endTime = moment(dates[dates.length-1])
    let endTime = moment(dates[dates.length-1]).add(60,'day')


    console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY hh:mm:ss"), value.y)
    })

    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = datesResampled[i].y
        for (var j=0;j<datesResampled.length;j++){
            if(i!=j){
                if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                    //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                    sum = Number(sum) + Number(datesResampled[j].y) 
                }  
            }
            
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
      // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            filled.push({ x: moment(startTime), y: 0 })
        startTime.add(1, 'day')
    }

    var resampledDates = []
    var resampledTss = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledTss.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

   
    return [resampledDates, resampledTss]
}



export function resamplePerformanceIndex(dates,index,timeframe='month') {
    if (dates.length<5){
        return  [dates, index]
    }
        
    let timeUnit = timeframe
    //console.log("date",dates,"index",index)
    let startTime = moment(dates[0]).subtract(2,'month').startOf(timeUnit)
   
    let sampleTime = moment(startTime)
    let samples = [{x: startTime,y: 0}]
    
    for (var i = 0; i < dates.length; i++) {
        samples.push({ x: moment(dates[i]).startOf(timeUnit), y: index[i] })
        //sampleTime.add(24, 'hours')
    }
    let endTime = moment().add(2,'month')
    //let endTime = moment(dates[dates.length-1])
    
    

    //console.log('samples-->')
    _.forEach(samples, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let datesResampled = _.map(samples, value => {
        let resampled = value.x.startOf(timeUnit)
        return { x: resampled, y: value.y }
    })

    //console.log('datesResampled-->')
    _.forEach(datesResampled, (value, key) => {
        //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })
    //console.log(dates)
    var datesReducedMy ={}
    for (var i=0;i<datesResampled.length;i++){
        var sum = parseFloat(datesResampled[i].y)
        var k = 1
        for (var j=0;j<datesResampled.length;j++){
            if(datesResampled[i].x.format("MM-DD-YYYY") === datesResampled[j].x.format("MM-DD-YYYY")){
                //console.log(datesResampled[i].x.format("MM-DD-YYYY"),datesResampled[j].x.format("MM-DD-YYYY"))
                sum = sum + parseFloat(datesResampled[j].y)
                k = k + 1
                
            }  
        }
        var nestedObject = {}
        if (!datesReducedMy[datesResampled[i].x]){
            nestedObject['x'] = moment(datesResampled[i].x)
            nestedObject['y'] = sum/k
            //nestedObject[moment(datesResampled[i].x)] = sum.toFixed(2)
            datesReducedMy[datesResampled[i].x.valueOf()] = nestedObject
        }
    }
    //console.log(datesReducedMy)
    ///let datesReduced = _.reduce(datesResampled, function (result, value, key) {
    //    result[value.x.valueOf()] = value
    //    return result
    //}, {})
    //console.log(datesReduced)
    const datesReduced = datesReducedMy
    //console.log('datesReduced-->')
    _.forEach(datesReduced, (value, key) => {
       //console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), value.y)
    })

    let filled = []
    while (startTime.isBefore(endTime)) {
        if (datesReduced[startTime.valueOf()])
            filled.push(datesReduced[startTime.valueOf()])

        else
            console.log("pass")
        startTime.add(1, timeframe)
    }

    var resampledDates = []
    var resampledindex = []
    //console.log('filled-->')
    _.forEach(filled, (value, key) => {
       // console.log('[', key, '] ', value.x.format("MM-DD-YYYY"), parseInt(value.y))
        resampledindex.push(parseInt(value.y))
        resampledDates.push(value.x.format("YYYY-MM-DD"))
    })

    return [resampledDates, resampledindex]
}


function arraysEqual(a,b){
    if (String(a) == String(b)){
        return true
    }
    else{
        return false
    }
}